/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

export class V1ResultIDs {
    /**
    * ID of the Org(s)
    */
    'orgId'?: string;
    /**
    * ID of the Campaign(s)
    */
    'campaignId'?: string;
    /**
    * ID of the OrderLine(s)
    */
    'orderLineId'?: string;
    /**
    * ID of the Creative(s)
    */
    'creativeId'?: string;
    /**
    * Bidder source identifier
    */
    'bidderSource'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "orgId",
            "baseName": "org_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "campaignId",
            "baseName": "campaign_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "orderLineId",
            "baseName": "order_line_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "creativeId",
            "baseName": "creative_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "bidderSource",
            "baseName": "bidder_source",
            "type": "string",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V1ResultIDs.attributeTypeMap;
    }

    public constructor() {
    }
}

